import type { Private } from '@seek/indie-api-types';
import {
  Loader,
  Stack,
  Tab,
  TabPanel,
  TabPanels,
  Tabs,
  TabsProvider,
  Text,
} from 'braid-design-system';
import { InlineCode } from 'scoobie';

import { RequestDetails } from './components/RequestDetails/RequestDetails.tsx';
import { ResponseDetails } from './components/ResponseDetails/ResponseDetails.tsx';

interface RequestProps {
  response: Private.TestCallOutput | undefined;
  request: Private.TestCallInput;
  loading: boolean;
}

export const Request = ({ response, request, loading }: RequestProps) => {
  if (loading || !response) {
    return (
      <Stack space="large">
        <Loader size="large" />

        <Text weight="strong">
          Sending a <InlineCode>{request.input.eventTypeCode}</InlineCode> event
          to <InlineCode>{request.url}</InlineCode>
        </Text>
      </Stack>
    );
  }
  return (
    <TabsProvider id="webhook-playground-request-tabs-provider">
      <Stack space="medium">
        <Tabs label="Test tabs" align="left" divider="full">
          <Tab>Response</Tab>
          <Tab>Request</Tab>
        </Tabs>
        <TabPanels>
          <TabPanel>
            <ResponseDetails response={response} request={request} />
          </TabPanel>
          <TabPanel>
            <RequestDetails response={response} request={request} />
          </TabPanel>
        </TabPanels>
      </Stack>
    </TabsProvider>
  );
};
